import { Footer } from "@/components/LandingPage/Footer";
import { GetStarted } from "@/components/LandingPage/GetStarted";
import { Prices } from "@/components/Pricing/Prices";
import { PricingDetails } from "@/components/Pricing/PricingDetails";
import { PricingHero } from "@/components/Pricing/PricingHero";

import { state } from "@/state";

import { Box } from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import type { GetServerSideProps, Metadata } from "next";
import { TestimonialsSection } from "@/components/LandingPage/TestimonialsSection";
import { Plan, PlanService } from "@/server/services/plan.service";

export const metadata: Metadata = {
  title: "Clarifayo",
  description: "Transparent Pricing",
};

export default function Page({ plans }: { plans: Plan[] }) {
  const router = useRouter();
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
    if (router.query.role) {
      state.role = router.query.role as any;
    }
  }, [router.query.role]);

  const snapshot = useSnapshot(state);
  // Use default role during SSR to prevent hydration mismatch
  const role = mounted ? snapshot.role : "coach";

  return (
    <>
      <Head>
        <title>Clarifayo - maximize your Coaching Activity</title>
      </Head>
      <Box bgColor="primary.100">
        <PricingHero />
        <Prices plans={plans} />
        {role !== "client" && <PricingDetails plans={plans} />}
        <TestimonialsSection />
        <GetStarted />
        <Footer />
      </Box>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const mergedPlans = await PlanService.listAll();
  return {
    props: {
      plans: mergedPlans,
    },
  };
};
